import styled from '@emotion/styled';

import { Grade } from '@/lib/apollo/types/gen/graphql';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { toHalfWidth } from '@/utility/utils';

const getBgColor = (
  isCanceled: boolean,
  gradeName: string,
  isToday: boolean,
) => {
  if (isCanceled !== undefined && isCanceled)
    return defaultTheme.background.mediumGray;
  if (gradeName) {
    // eslint-disable-next-line default-case
    switch (toHalfWidth(gradeName)) {
      case Grade.Gp: {
        return '#FFF8E3';
      }
      case Grade.G1: {
        return '#FFEBF1';
      }
      case Grade.G2: {
        return '#F5E7F7';
      }
      case Grade.G3: {
        return '#E9EAFC';
      }
      case Grade.F1: {
        return '#FFF3E0';
      }
      case Grade.F2: {
        return '#E0F5FD';
      }
    }
  }
  if (isToday) return '#E65C7E';
  return defaultTheme.background.white;
};

export const TableData = styled.td(
  (props: {
    hasNoBorder: boolean;
    gradeName: string;
    isCanceled: boolean;
    isToday: boolean;
  }) =>
    mq({
      width: 'max-content',
      height: '100%',
      padding: `${defaultTheme.spacing.s} ${defaultTheme.spacing.xs}`,
      borderBottom: `1px solid ${defaultTheme.border.color.black}`,
      borderLeft:
        !props.hasNoBorder &&
        `1px solid ${defaultTheme.border.color.mediumGray}`,
      backgroundColor: getBgColor(
        props.isCanceled,
        props.gradeName,
        props.isToday,
      ),
      // SafariではBorderBottomが上に表示されてしまうため、doubleで表示するようにする
      '@media not all and (min-resolution:.001dpcm)': {
        '@supports (-webkit-appearance:none)': {
          borderBottom: `1px double ${defaultTheme.border.color.black} !important`,
        },
      },
    }),
);

export const VelodromeName = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    width: '24px',
    textAlign: 'center',
  }),
);

export const Content = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    display: 'grid',
    gridTemplateColumns: `repeat(1, 1fr)`,
    gap: defaultTheme.spacing.xs,
    justifyItems: 'center',
  }),
);

export const Note = styled.div(() =>
  mq({
    color: defaultTheme.color.grayScale.dark,
  }),
);
